






























import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Step1 from '../Step1.vue'
import Step2 from '../Step2.vue'
import TaskApi from '@/api/task'
import bus from '../bus'

@Component({
	name: 'AiiAddResurvey',
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
		PageLayout,
		Step1,
		Step2,
	},
})
export default class AddTask extends Vue {
	private currentTab: any = 0
	private data: any = {}
	private resurveyOrder: any = false

	private nextStep() {
		if (this.currentTab < 2) {
			this.currentTab += 1
		}
	}

	private setManual2Injured(checked: boolean) {
		this.data.manual2Injured = checked
	}

	private clickPrev(form: any) {
		this.data = {
			...this.data,
			...form,
		}
		this.prevStep()
	}

	private resetCurrent() {
		this.currentTab = 0
	}

	private onOk() {
		this.data = {}
		this.prevStep()
	}

	private get insuranceValue() {
		const value = this.$store.state.setting.insuranceTypeMap[
			this.data.insuranceType
		]
		if (value) {
			return `（${value}）`
		}
		return ''
	}

	private chooseInsuranceType(form: any) {
		this.data = {
			...this.data,
			...form,
		}
		this.nextStep()
	}

	private prevStep() {
		if (this.currentTab > 0) {
			this.currentTab -= 1
		}
	}

	private finish() {
		this.currentTab = 0
	}

	private activated() {
		this.resurveyInit()
	}

	private async resurveyInit() {
		const resurvey = this.$route.query.resurvey
		if (resurvey === '1') {
			const resurveyOrder = this.$ss.get('resurveyOrder')
			if (!resurveyOrder) {
				return
			}
			if (resurveyOrder.isWholeProcess) {
				const obj: any = { orderId: resurveyOrder.orderId }
				if (resurveyOrder.revisitId) {
					obj.revisitId = resurveyOrder.revisitId
				}
				const res = await TaskApi.getFirstTaskInfo(obj)
				this.$set(resurveyOrder, 'insuranceType', res.data.insuranceType)
				this.$set(resurveyOrder, 'isSendManual', res.data.isSendManual)
			} else {
				const res = await TaskApi.getOrderExStatusInfo(resurveyOrder.orderId)
				this.$set(resurveyOrder, 'insuranceType', res.data.insuranceType)
			}

			this.data = {
				insuranceType: resurveyOrder.insuranceType,
			}
			if (resurveyOrder.isWholeProcess) {
				// 保存全流程初次探视是否发送服务手册
				this.$set(this.data, 'manual2Injured', resurveyOrder.isSendManual)
			}
			this.resurveyOrder = resurveyOrder
		}
	}
}
